import { Endpoints } from "services/api";
import { ApiError, ErrorResponse, getFetch } from "@wexinc/wex-common-web";
import { LoginInfo, PasswordRequestInfo } from "./models";

const apiRoot = "users";

const { get, post } = getFetch(Endpoints.apiRoot);

function resetPasswordRequest(email: string) {
  return post({
    relativeRoute: `public/${apiRoot}/password-reset`,
    body: { email },
    skipAuthHeader: true,
    responseErrorHandler: async (response) => {
      const errorMessage = (await response.json()) as ErrorResponse;
      return Promise.reject(new ApiError(errorMessage));
    },
  });
}

function getPasswordResetRequestInfo(passwordResetId: number, resetToken: string): Promise<PasswordRequestInfo> {
  return get({
    relativeRoute: `${apiRoot}/password-reset/${passwordResetId}`,
    customAccessToken: resetToken,
    responseErrorHandler: async (response) => {
      const errorMessage = (await response.json()) as ErrorResponse;
      return Promise.reject(new ApiError(errorMessage));
    },
  });
}

function resetPassword(passwordResetId: number, password: string, resetToken: string) {
  return post({
    relativeRoute: `${apiRoot}/password-reset/${passwordResetId}`,
    customAccessToken: resetToken,
    body: { password },
  });
}

async function getUserLoginInfo(email: string): Promise<LoginInfo> {
  return post({
    relativeRoute: `public/${apiRoot}/login-info`,
    body: { email },
    skipAuthHeader: true,
  });
}

export { resetPasswordRequest, getPasswordResetRequestInfo, resetPassword, getUserLoginInfo };
